import {selectUserId} from '~/ViewInvitation/selectors/user';

export const selectWhatToBring = ({whatToBring}) => whatToBring;

export const selectWhatToBringItems = (state) => selectWhatToBring(state)?.items;

export const selectUserHasWTBSignUp = (state) => {
  const userId = selectUserId(state);
  const items = selectWhatToBringItems(state) || [];
  const allIds = items
    .flatMap((item) => item.selections || [])
    .map((sel) => sel.user?.id)
    .filter(Boolean);
  return allIds.includes(userId);
};

export const selectWhatToBringListId = ({whatToBringSummary: wtbs}) => wtbs?.list_id;
